import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const IdNo = (props) => {
  return (
    <FormGroup controlId="idNo">
      <Col componentClass={ControlLabel} sm={5}>
        ID No. / Cert. of Incorporation Cert of Reg. No. #
      </Col>
      <Col sm={7}>
        <FormControl
        type="text"
        value={props.id}
        onChange={props.handleChangeIdNo}
        required={props.required}
        autoComplete="off" />
      </Col>
    </FormGroup>
  )
}

IdNo.propTypes = {
  id: PropTypes.string,
  required: PropTypes.bool,
  handleChangeIdNo: PropTypes.func
};

export default IdNo;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/idNo/IdNo.js